import React, { useEffect, useState } from 'react';

import styles from './DogCardLooseTests.module.scss';
import { useTranslate } from 'react-polyglot';
import { useAuth } from '../../../../../../Auth';
import { useAxios } from '../../../../../../AxiosHandler';
import Card from '../../../../../Shared/Card/Card';
import BarGraphCard from '../../../../Statistics/Cards/BarGraphCard/BarGraphCard';

function DogCardLooseTests(props: DogCardLooseTestsProps) {
    const t = useTranslate();
    const auth = useAuth();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const [data, setData] = useState<any>();

    const [openTest, setOpenTest] = useState<string>("");
    
    function getData() {
        if (auth.selectedBreed == undefined) return;
        axios.single({
            method: 'get',
            url: "/api/statistics/dog/" + props.dogId + "/use/loose/tests",
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res) => {
            setData(res.data);
            props.onDataLoaded?.(res.data);
        }).catch((err: any) => {
            console.log(err);
        });
    }

    useEffect(() => {
        getData();
    }, [props.dogId]);

    return (
        <div className={styles.statisticsloosetests}>
            <Card
                title={t("dog.statistics.loosetests.title")}
                children={<div>
                    {data?.map((item: any, index: any) => {
                        let date = new Date(item["TEST_DATE"]);
                        let year = date.getFullYear();

                        // Day padded with 0
                        let day = ("0" + date.getDate()).slice(-2);

                        // Month padded with 0
                        let month = ("0" + (date.getMonth() + 1)).slice(-2);

                        return <div
                            key={item["ID"] + "_" + index}
                            className={styles.test}
                        >
                            <div
                                className={styles.testheader}
                                onClick={() => setOpenTest(openTest == (item["ID"] + "_" + index) ? "" : (item["ID"] + "_" + index))}
                            >
                                <div className={styles.testdate}>
                                    <span>{day}.{month}</span>
                                    <span>{year}</span>
                                </div>
                                <div className={styles.testname}>
                                    <span>{item["TEST_ID"]}</span>
                                    <span>{item["ORGANIZER_NAME"]}</span>
                                    {/*<span>{item["TERRENG"]}{ item["TERRENG"] && item["KOMMUNE"] ? ", " : "" }{item["KOMMUNE"]}</span>*/}
                                </div>
                                <div className={styles.testresult}>
                                    <span>
                                        {item["PRIZE"] != 0 ?
                                            t("dog.statistics.loosetests.results.prize") + ": " + item["PRIZE"] + ". " + t("dog.statistics.loosetests.results.place")
                                        : <strong>&nbsp;</strong>}
                                    </span>
                                    <span>
                                        {t("dog.statistics.loosetests.results.points")}: {item["POINTS"]}
                                    </span>
                                </div>
                            </div>
                            <div className={styles.testcontent} style={{ display: openTest == (item["ID"] + "_" + index) ? "block" : "none" }}>
                                <BarGraphCard
                                    title=''
                                    data={{
                                        labels: [
                                            "M1",
                                            "M2",
                                            "M3",
                                            "M4",
                                            "M5",
                                            "M6",
                                            "M7",
                                            "M8",
                                            "M9",
                                            "M10",
                                            "M10A",
                                            "M10B",
                                            "M10C",
                                        ],
                                        datasets: [
                                            {
                                                label: t("dog.statistics.loosetests.results.title"),
                                                data: [
                                                    item["M1"],
                                                    item["M2"],
                                                    item["M3"],
                                                    item["M4"],
                                                    item["M5"],
                                                    item["M6"],
                                                    item["M7"],
                                                    item["M8"],
                                                    item["M9"],
                                                    item["M10"],
                                                    item["M10A"],
                                                    item["M10B"],
                                                    item["M10C"],
                                                ],
                                                backgroundColor: "#68db5a",
                                            }
                                        ]
                                    }}
                                    options={{
                                        plugins: {
                                            legend: {
                                                display: true
                                            }
                                        },
                                        scales: {
                                            y: {
                                                suggestedMax: 10,
                                                suggestedMin: 0,
                                                beginAtZero: true,
                                            }
                                        }
                                    }}
                                ></BarGraphCard>
                                { item["PDF_URL"] ?
                                    <p><a href={"https://www.dogweb.no/" + item["PDF_URL"]} target="_blank" rel="noreferrer">PDF (Dogweb)</a></p>
                                : ""}
                            </div>
                        </div>;
                    })}
                </div>}
            />
        </div>
    );
}

class DogCardLooseTestsProps {
    dogId!: string | undefined;
    onDataLoaded?: (data: any) => void;
}

export default DogCardLooseTests;